import React from 'react';

export default function SeccionPreguntasSST({ titulo, icono, preguntas, respuestas, observaciones, onResponder, onObservacion, evidenciasFotos, onFotoPregunta }) {
  // Calculamos el progreso visual de esta sección específica
  const respondidas = preguntas.filter(p => respuestas[p.id] !== undefined).length;
  const total = preguntas.length;
  const completado = respondidas === total;

  return (
    <div className={`bg-white/50 backdrop-blur-xl p-5 sm:p-7 rounded-[32px] shadow-sm border transition-all duration-300 mb-6 ${completado ? 'border-emerald-400/50 shadow-emerald-500/10' : 'border-white/90'}`}>
      
      {/* TÍTULO Y BARRA DE PROGRESO DE LA SECCIÓN */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 bg-gradient-to-r from-slate-900 to-slate-800 p-4 rounded-[20px] text-white shadow-md">
        <div className="flex items-center gap-3">
          <span className="text-2xl bg-white/10 w-10 h-10 flex items-center justify-center rounded-xl border border-white/10 shadow-inner">
            {icono}
          </span>
          <h3 className="text-sm sm:text-base font-black uppercase tracking-widest">{titulo}</h3>
        </div>
        <div className="flex items-center gap-2 bg-black/30 px-3 py-1.5 rounded-lg border border-white/10">
          <span className="text-[10px] font-bold text-slate-300 uppercase tracking-wider">Progreso:</span>
          <span className={`text-xs font-black ${completado ? 'text-emerald-400' : 'text-blue-300'}`}>
            {respondidas} / {total}
          </span>
        </div>
      </div>

      {/* LISTA DINÁMICA DE PREGUNTAS */}
      <div className="space-y-3">
        {preguntas.map((preg, index) => {
          const valorActual = respuestas[preg.id];
          const esNoCumple = valorActual === 0 || valorActual === "NO_CUMPLE";
          const tieneObservacion = observaciones[preg.id]?.length > 0;
          const fotoActual = evidenciasFotos ? evidenciasFotos[preg.id] : null;

          return (
            <div key={preg.id} className={`p-4 sm:p-5 rounded-[24px] border transition-all duration-200 flex flex-col gap-4 ${
              valorActual !== undefined ? 'bg-white/80 border-slate-200 shadow-sm' : 'bg-white/40 border-white hover:bg-white/60'
            }`}>
              
              <div className="flex flex-col lg:flex-row gap-4 lg:items-center">
                {/* Texto de la pregunta */}
                <div className="flex-1">
                  <div className="flex gap-3">
                    <span className="text-xs font-black text-slate-400 mt-0.5">{index + 1}.</span>
                    <p className={`text-sm font-bold leading-snug ${valorActual !== undefined ? 'text-slate-900' : 'text-slate-600'}`}>
                      {preg.texto}
                    </p>
                  </div>
                </div>

                {/* Controles de Acción (Botones e Input) */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 lg:w-[480px] shrink-0 pl-7 lg:pl-0">
                  
                  {/* Botones Cumple / No Cumple */}
                  <div className="flex bg-slate-100/50 p-1 rounded-[16px] border border-slate-200/60 shrink-0 shadow-inner">
                    <button
                      onClick={() => onResponder(titulo, preg.id, 1)}
                      className={`flex-1 sm:flex-none px-4 py-2.5 rounded-[12px] text-[11px] font-black transition-all cursor-pointer ${
                        valorActual === 1 
                          ? 'bg-emerald-500 text-white shadow-[0_4px_12px_rgba(16,185,129,0.3)] scale-100' 
                          : 'bg-transparent text-slate-500 hover:bg-emerald-100/50 hover:text-emerald-700 scale-95 opacity-70'
                      }`}
                    >
                      ✓ CUMPLE
                    </button>
                    <button
                      onClick={() => onResponder(titulo, preg.id, 0)}
                      className={`flex-1 sm:flex-none px-4 py-2.5 rounded-[12px] text-[11px] font-black transition-all cursor-pointer ${
                        valorActual === 0 
                          ? 'bg-red-500 text-white shadow-[0_4px_12px_rgba(239,68,68,0.3)] scale-100' 
                          : 'bg-transparent text-slate-500 hover:bg-red-100/50 hover:text-red-700 scale-95 opacity-70'
                      }`}
                    >
                      ✕ NO CUMPLE
                    </button>
                  </div>

                  {/* Input de Observaciones */}
                  <div className="flex-1 relative">
                    <input 
                      type="text"
                      value={observaciones[preg.id] || ''}
                      onChange={(e) => onObservacion(titulo, preg.id, e.target.value)}
                      placeholder="Observaciones..."
                      className={`w-full bg-white/70 border focus:bg-white rounded-xl px-4 py-2.5 text-xs font-medium outline-none transition-all shadow-[inset_0_2px_4px_rgba(0,0,0,0.02)] placeholder:text-slate-400 ${
                        tieneObservacion ? 'border-blue-400' : 'border-slate-200 focus:border-blue-400'
                      }`}
                    />
                    {tieneObservacion && <span className="absolute right-3 top-2.5 text-[12px]">📝</span>}
                  </div>

                </div>
              </div>

              {/* SE DESPLIEGA AUTOMÁTICAMENTE AL MARCAR NO CUMPLE PARA ADJUNTAR FOTO */}
              {esNoCumple && (
                <div className="pt-3 mt-1 border-t border-slate-200/70 flex flex-col sm:flex-row items-center justify-between gap-3 bg-slate-50/80 p-3 rounded-2xl animate-fade-in">
                  <div className="flex items-center gap-2.5 w-full sm:w-auto">
                    <span className="text-base">📸</span>
                    <span className="text-xs font-bold text-slate-700">
                      {fotoActual ? "Fotografía de evidencia adjunta ✅" : "Evidencia fotográfica obligatoria/sugerida por incumplimiento"}
                    </span>
                  </div>

                  <div className="flex items-center gap-3 w-full sm:w-auto justify-end">
                    {fotoActual && (
                      <div className="w-10 h-10 rounded-xl overflow-hidden border border-slate-300 shadow-xs shrink-0">
                        <img src={fotoActual} alt="Evidencia" className="w-full h-full object-cover" />
                      </div>
                    )}
                    <label className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-xs font-black transition cursor-pointer shadow-sm shrink-0">
                      <span>{fotoActual ? "Cambiar Foto" : "Subir Foto"}</span>
                      <input
                        type="file"
                        accept="image/*"
                        capture="environment"
                        className="hidden"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              if (onFotoPregunta) onFotoPregunta(preg.id, reader.result);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                      />
                    </label>
                  </div>
                </div>
              )}

            </div>
          );
        })}
      </div>
    </div>
  );
}